import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzK9 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_K9: Record<
  PageIdWoofzK9,
  TPageConfig
> = {
  [PageIdWoofzK9.DOG_AGE_K9]: {
    id: PageIdWoofzK9.DOG_AGE_K9,
    hasHeader: true,
  },
  [PageIdWoofzK9.DOG_SEX_K9]: {
    id: PageIdWoofzK9.DOG_SEX_K9,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.DOG_BREED_K9]: {
    id: PageIdWoofzK9.DOG_BREED_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9.DOG_BREED_ID_K9]: {
    id: PageIdWoofzK9.DOG_BREED_ID_K9,
  },
  [PageIdWoofzK9.URGE_K9]: {
    id: PageIdWoofzK9.URGE_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.CHALLENGES_K9]: {
    id: PageIdWoofzK9.CHALLENGES_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9.URGE_1_K9]: {
    id: PageIdWoofzK9.URGE_1_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.LEASH_PULLING_K9]: {
    id: PageIdWoofzK9.LEASH_PULLING_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9.URGE_LEASH_K9]: {
    id: PageIdWoofzK9.URGE_LEASH_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.DURING_WALK_K9]: {
    id: PageIdWoofzK9.DURING_WALK_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9.URGE_NOT_ALONE_K9]: {
    id: PageIdWoofzK9.URGE_NOT_ALONE_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.AGRESSIVE_BEHAVIOR_K9]: {
    id: PageIdWoofzK9.AGRESSIVE_BEHAVIOR_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9.TRIGGERS_K9]: {
    id: PageIdWoofzK9.TRIGGERS_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9.URGE_2_K9]: {
    id: PageIdWoofzK9.URGE_2_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.BEHAVIOR_ISSUES_K9]: {
    id: PageIdWoofzK9.BEHAVIOR_ISSUES_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9.DOG_ACT_K9]: {
    id: PageIdWoofzK9.DOG_ACT_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9.DOG_OFF_AT_HOME_K9]: {
    id: PageIdWoofzK9.DOG_OFF_AT_HOME_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9.REWARDS_K9]: {
    id: PageIdWoofzK9.REWARDS_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9.IGNORE_COMMANDS_K9]: {
    id: PageIdWoofzK9.IGNORE_COMMANDS_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9.COMMANDS_61_K9]: {
    id: PageIdWoofzK9.COMMANDS_61_K9,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.COMMANDS_62_K9]: {
    id: PageIdWoofzK9.COMMANDS_62_K9,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.COMMANDS_63_K9]: {
    id: PageIdWoofzK9.COMMANDS_63_K9,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.URGE_3_K9]: {
    id: PageIdWoofzK9.URGE_3_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.PREPARE_SCREEN_K9]: {
    id: PageIdWoofzK9.PREPARE_SCREEN_K9,
    hasHeader: true,
  },
  [PageIdWoofzK9.DOG_PROFILE_K9]: {
    id: PageIdWoofzK9.DOG_PROFILE_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.URGE_REVIEWED_K9]: {
    id: PageIdWoofzK9.URGE_REVIEWED_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.SOCIAL_SCREEN_K9]: {
    id: PageIdWoofzK9.SOCIAL_SCREEN_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.PREPARE_FLOW_K9]: {
    id: PageIdWoofzK9.PREPARE_FLOW_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.EMAIL_K9]: {
    id: PageIdWoofzK9.EMAIL_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.NEWSLETTER_URGE_K9]: {
    id: PageIdWoofzK9.NEWSLETTER_URGE_K9,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9.DISCIPLINE_SCREEN_K9]: {
    id: PageIdWoofzK9.DISCIPLINE_SCREEN_K9,
    hasHeader: true,
  },
  [PageIdWoofzK9.SCRATCH_SCREEN_K9]: {
    id: PageIdWoofzK9.SCRATCH_SCREEN_K9,
    hasHeader: true,
  },
  [PageIdWoofzK9.WELCOME_TO_WOOFZ_K9]: {
    id: PageIdWoofzK9.WELCOME_TO_WOOFZ_K9,
    hasHeader: true,
  },
  [PageIdWoofzK9.SUBSCRIPTIONS_K9]: {
    id: PageIdWoofzK9.SUBSCRIPTIONS_K9,
  },
  [PageIdWoofzK9.CHAT_UPSELL_K9]: {
    id: PageIdWoofzK9.CHAT_UPSELL_K9,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9.UPSELL_K9]: {
    id: PageIdWoofzK9.UPSELL_K9,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9.UPSELL_FEEDING_GUIDE_K9]: {
    id: PageIdWoofzK9.UPSELL_FEEDING_GUIDE_K9,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9.UPSELL_EMOTIONAL_SUPPORT_K9]: {
    id: PageIdWoofzK9.UPSELL_EMOTIONAL_SUPPORT_K9,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9.DOWNLOAD_K9]: {
    id: PageIdWoofzK9.DOWNLOAD_K9,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9.ACCOUNT_K9]: {
    id: PageIdWoofzK9.ACCOUNT_K9,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
